import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import IncidentsByPiriods from './IncidentsByPiriods';
import IncidentsByDailyWeekly from './IncidentsByDailyWeekly';
import ImportantStatus from './ImportantStatus';
import IncidentsByLocation from './IncidentsByLocation';
import TypeCountsWithRank from './TypeCountsWithRank';
import { ValidatorForm } from 'components';
import Branches from 'AutoComplites/Branches';
import { isMobile } from 'Utils';
import MobileDashboard from './MobileDashboard';

const Dashboard = () => {
  const [formData, setFormData] = useState({ branch_id: null })
  const [isMobileView, setIsMobileView] = useState(false)

  useEffect(() => {
    setIsMobileView(isMobile)
  }, []);


  return (
    <div className='w-full'>
      <div className='w-full pb-4'>
        <ValidatorForm>
          <Branches
            name="branch_id"
            label=""
            placeholder="Select Branch"
            value={formData.branch_id || null}
            onChange={(e, value) => {
              setFormData({ ...formData, branch_id: value?.id || null });
            }}

          >
          </Branches>
        </ValidatorForm>
      </div>

      {isMobileView ?
        <div className='w-full'>
          <MobileDashboard filters={formData}></MobileDashboard>
        </div>
        :

        <Grid container spacing={1}>

          <Grid item size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <ImportantStatus filters={formData} />
          </Grid>
          <Grid item size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <IncidentsByPiriods filters={formData} />
          </Grid>

          <Grid item size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <IncidentsByDailyWeekly filters={formData} />
          </Grid>
          <Grid item size={{ lg: 8, md: 8, sm: 12, xs: 12 }}>
            <IncidentsByLocation filters={formData} />
          </Grid>
          <Grid item size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
            <TypeCountsWithRank filters={formData} />
          </Grid>



        </Grid>
      }



      <div className="flex">



      </div>
    </div>
  );
};

export default Dashboard; 